// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ulBz","left":"styles_left__3kBrc"};